var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_4435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.95172 7.31246C3.95079 6.64534 4.08191 5.98463 4.33751 5.36842C4.59312 4.75221 4.96816 4.19269 5.44102 3.7221C5.91388 3.25151 6.4752 2.87917 7.09263 2.62653C7.71007 2.37389 8.3714 2.24596 9.0385 2.2501C11.8222 2.27079 14.0487 4.58457 14.0487 7.37601V7.87496C14.0487 10.3932 14.5756 11.8546 15.0396 12.6533C15.0896 12.7386 15.1162 12.8356 15.1168 12.9345C15.1173 13.0334 15.0917 13.1307 15.0427 13.2166C14.9936 13.3025 14.9227 13.3739 14.8372 13.4236C14.7518 13.4734 14.6547 13.4997 14.5558 13.5H3.44411C3.34519 13.4997 3.24809 13.4734 3.1626 13.4236C3.07712 13.3738 3.00627 13.3024 2.9572 13.2165C2.90813 13.1306 2.88258 13.0333 2.88313 12.9344C2.88367 12.8355 2.9103 12.7385 2.96031 12.6531C3.4246 11.8544 3.95172 10.3931 3.95172 7.87496L3.95172 7.31246Z",
    stroke: "#000929",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.5V14.0625C6.75 14.6592 6.98705 15.2315 7.40901 15.6535C7.83097 16.0754 8.40326 16.3125 9 16.3125C9.59674 16.3125 10.169 16.0754 10.591 15.6535C11.0129 15.2315 11.25 14.6592 11.25 14.0625V13.5",
    stroke: "#000929",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_4435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.d201a80c90b563d5f49a4f758b698564.svg";
export { ForwardRef as ReactComponent };